import { useContext, useEffect, useRef, useState } from "react";
import Btn_loader from "../Btn_loader";
import { MyContext } from "../../Context/MyProvider";
import secureLocalStorage from "react-secure-storage";
import LottieImg from "../../image/discount-voucher.png";
import ExtraLottie from "../../Lottie/coupon_appy.json";
import Lottie from 'lottie-react';
import ImageLoad from "../ImageLoad";
import { useLocation, useNavigate } from "react-router-dom";
import Razorpay from "../../Payment-Getway/Razorpay";
import { socket } from "../../socket";
import AllPayment from "../../Payment-Getway/AllPayment";
import { useTranslation } from "react-i18next";
import { ArrowLeft, Calendar, MapPin, Check, Plus, X } from "lucide-react";
const BookApoint = ({ KundliList, userdata, isclickindex, setIsChatPayModel, user_wallet }) => {

    const { t } = useTranslation();
    const { BaseUrl, setIsToast, setToastMsg, HandleCallApi, paymentRes, setPaymentRes, paymentloading, setPaymentLoading, formatPrice } = useContext(MyContext);

    const [selectuser, setSelectUser] = useState("");
    const [apiloading, setApiLoading] = useState("");
    const [pricelist, setPriceList] = useState([]);
    const [ischatstep, setIsChatStep] = useState(1);
    const [seletprice, setSelectPrice] = useState("");
    const [isextramodel, setIsExtraModel] = useState(false);
    const [ispaymentmodelm, setIsPaymentModel] = useState(false);
    const [rechargeamount, setRechargeAmount] = useState(0);
    const [gstamount, setGstAmount] = useState(0);
    const [paybleamount, setPaybleAmount] = useState(0);
    const [wallettoggle, setWalletToggle] = useState(false);
    const [paymentlist, setPaymentList] = useState([]);
    const [selectpayment, setSelectPayment] = useState("");
    const [attributes, setAttributes] = useState("");
    const [istrue, setIsTrue] = useState(false);
    const [userwallet, setUserWallet] = useState(Number(user_wallet || 0));
    const userwalletcopy = Number(user_wallet || 0);

    const navigate = useNavigate();
    const PaymentModeRef = useRef();
    const PaymentRef = useRef(false);
    const Location = useLocation();

    const Currency = secureLocalStorage.getItem("currency") || "$";
    const Tex = secureLocalStorage.getItem("tex");

    useEffect(() => {
        const Userid = secureLocalStorage.getItem("Userid");
        if (Userid) {
            handleGetPaymentList(Userid);
        }
        if (KundliList.length <= 0) {
            setIsChatStep(1);
        }
    }, []);

    useEffect(() => {
        if (wallettoggle) {
            const GetTotal = paybleamount - user_wallet;
            setPaybleAmount(GetTotal);
            setUserWallet(0);
        } else {
            setPaybleAmount(prev => prev + userwalletcopy);
            setUserWallet(userwalletcopy);
        }
    }, [wallettoggle]);


    useEffect(() => {
        if (!paymentRes) return;
        if (paymentRes === "PaymentDone") {
            handleBookAppointment();
        } else {
            setIsToast(true);
            setToastMsg("Payment faild !!");
            setPaymentRes("");
            setIsTrue(false);
        }
    }, [paymentRes]);

    const handleGetPaymentList = async (id) => {
        if (PaymentRef.current) return;
        PaymentRef.current = true;
        const Response = await HandleCallApi("Get", "user/payment_list", { id });
        setPaymentList(Response.data.payment_list);
    }

    const handleGetTotalPrice = () => {

        if (isclickindex === 1) {
            const OfferPrice = userdata?.chat_offer_price || userdata?.chat_off_price;
            const GetChatTotal = (userdata?.chat_min_req_time * OfferPrice);
            return GetChatTotal;
        }

        if (isclickindex === 2) {
            const GetCallTotal = (userdata?.audio_min_req_time * userdata.audio_offer_price);
            return GetCallTotal;
        }

        if (isclickindex === 3) {
            const GetVideoTotal = (userdata?.video_min_req_time * userdata.video_offer_price);
            return GetVideoTotal;
        }
    }

    const handleMinReqTime = () => {
        if (isclickindex === 1) {
            const GetChatTime = userdata?.chat_min_req_time;
            return GetChatTime;
        }

        if (isclickindex === 2) {
            const GetCallTime = userdata?.audio_min_req_time;
            return GetCallTime;
        }

        if (isclickindex === 3) {
            const GetVideoTime = userdata?.video_min_req_time;
            return GetVideoTime;
        }
    }

    const handleNext = async () => {

        if (!selectuser) {
            setIsToast(true);
            setToastMsg("Please select user !!");
            return;
        }

        const GetTotal = handleGetTotalPrice();

        if (userwallet < GetTotal) {
            setApiLoading("Next");
            const Response = await HandleCallApi("Post", "user/pricing_list", { amount: GetTotal });
            if (Response && Response.data) {
                setPriceList(Response.data.pricing_list);
            }
            setApiLoading("");
            setIsChatStep(2);
        } else {
            await handleBookAppointmentwallet();
        }
    }

    const handleProceedToPay = async () => {

        if (!seletprice && pricelist.length > 1) {
            setIsToast(true);
            setToastMsg("Please select amount !!");
            return;
        }

        if (pricelist.length <= 0) {
            handleBookAppointmentwallet();
        } else {

            if (seletprice?.offer_title !== 0) {
                setIsExtraModel(true);
            }

            const Price = seletprice ? seletprice.price : handleGetTotalPrice();;
            setRechargeAmount(Price.toFixed(2));
            const GetGST = (Price * Tex) / 100;
            setGstAmount(Number(GetGST.toFixed(2)));
            setPaybleAmount(Price + GetGST);
            setIsChatStep(3);

            setIsPaymentModel(true);
            const Timeout = setTimeout(() => {
                PaymentModeRef.current.classList.add("payment_model_open");
            }, 100);

            return () => clearTimeout(Timeout);
        }
    }

    const handleBookAppointmentwallet = async () => {

        const Userid = secureLocalStorage.getItem("Userid");

        const astrologer_id = Location.pathname.startsWith("/chat") ? userdata?.astrologer_id : userdata?.id;

        if (Userid) {
            const ApiData = {
                id: Userid,
                astrologer_id,
                kundli_user_id: selectuser ? selectuser.id : "",
                appointment_type: isclickindex,
                appointment_time: await handleGetAppointmentTime(),
                amount: await handleGetTotalPrice(),
                wallet_amount: await handleGetTotalPrice(),
                base_amount: 0,
                tax_amount: 0,
                offer_amount: 0,
                paymentId: "",
                transactionId: ""
            }

            setApiLoading("ProceedtoPay");
            const Response = await HandleCallApi("Post", "user/add_appointment", ApiData);
            if (Response && Response.data) {
                socket.emit("new_appointment", { astrologer_id: String(ApiData?.astrologer_id) });
                setIsToast(true);
                setToastMsg(Response.data.message);
                navigate("/");
            }
            setApiLoading("");
        }
    }

    const handleCloseModel = (index) => {
        if (index === 1) {
            setIsChatPayModel(false);
            setIsChatStep(1);
            setPriceList([]);
        }

        if (index === 2) {

            if (wallettoggle) {
                setWalletToggle(false);
            }

            PaymentModeRef.current.classList.remove("payment_model_open");
            const Timeout = setTimeout(() => {
                setIsPaymentModel(false);
                setIsChatStep(2);
            }, 500);
            return () => clearTimeout(Timeout);
        }
    }

    const handleGetAppointmentTime = () => {
        if (isclickindex === 1) {
            const GetChatTime = userdata?.chat_min_req_time + userdata?.chat_free_minute;
            return GetChatTime;
        }

        if (isclickindex === 2) {
            const GetCallTime = userdata?.audio_min_req_time + userdata?.audio_free_minute;
            return GetCallTime;
        }

        if (isclickindex === 3) {
            const GetVideoTime = userdata?.video_min_req_time + userdata?.video_free_minute;
            return GetVideoTime;
        }
    }

    const handleContinue = async () => {

        if (!selectpayment) {
            setIsToast(true);
            setToastMsg("Please select payment method !!");
            return;
        }

        const Userid = secureLocalStorage.getItem("Userid");

        if (Userid) {
            const offer_amount = seletprice ? (seletprice.price * seletprice.offer_title) / 100 : 0;
            const astrologer_id = userdata?.astrologer_id || userdata?.id;

            const ApiData = {
                id: Userid,
                astrologer_id,
                kundli_user_id: selectuser.id,
                appointment_type: isclickindex,
                appointment_time: await handleGetAppointmentTime(),
                amount: await handleGetTotalPrice(),
                wallet_amount: wallettoggle ? user_wallet : 0,
                base_amount: paybleamount,
                tax_amount: gstamount,
                offer_amount,
                paymentId: selectpayment,
            }
            secureLocalStorage.setItem("Bookingdata", JSON.stringify(ApiData));
            secureLocalStorage.setItem("Page", `astrologers/${astrologer_id}`);
        }

        setPaymentLoading(true);
        setIsTrue(true);
    }

    const handleBookAppointment = async () => {

        const GetBookingData = secureLocalStorage.getItem("Bookingdata");
        const transactionId = sessionStorage.getItem("transactionid");
        let Timeout;

        if (GetBookingData && GetBookingData !== "null" && GetBookingData !== "undefined") {
            try {
                const BookingData = typeof GetBookingData === 'string' ? JSON.parse(GetBookingData) : GetBookingData;
                if (BookingData) {
                    setApiLoading("Isbooking");
                    const Response = await HandleCallApi("Post", "user/add_appointment", { ...BookingData, transactionId });
                    if (Response && Response.data) {
                        setIsToast(true);
                        setToastMsg(Response.data.message);
                        if (Response.data.ResponseCode === 200) {
                            if (PaymentModeRef.current) {
                                PaymentModeRef.current.classList.remove("payment_model_open");
                            }
                            Timeout = setTimeout(() => {
                                setIsPaymentModel(false);
                            }, 500);
                            setPaymentRes("");
                            handleCloseModel(1);
                            setIsTrue(false);
                            secureLocalStorage.removeItem("Bookingdata");
                            sessionStorage.removeItem("transactionid");
                            navigate("/");
                        }
                    }
                    setApiLoading("");
                    return () => clearTimeout(Timeout);
                }
            } catch (e) {
                console.error("Error booking appointment in BookApoint:", e);
                setApiLoading("");
            }
        }

    }

    return (
        <div>

            {ischatstep !== 3 && <div onClick={() => handleCloseModel(1)} className="model items-center">
                <div onClick={(e) => e.stopPropagation()} className="chat_pay_model">
                    {ischatstep === 1 && <div>
                        <div className="flex items-center gap-3 pb-3 mb-3 border-b border-gray-100">
                            <button onClick={() => handleCloseModel(1)} className="p-1 rounded-full hover:bg-gray-100 transition-colors">
                                <ArrowLeft className="w-5 h-5 text-gray-700" />
                            </button>
                            <h1 className='font-semibold text-[18px] text-gray-900'>{t("Select Kundli")}</h1>
                        </div>
                        <div className='select_kundli_list'>
                            {KundliList.map((item, index) => {
                                const IsSelected = item.id === selectuser?.id;
                                return (
                                    <div 
                                        key={index} 
                                        onClick={() => setSelectUser(item)} 
                                        className={`kundli_select_card ${IsSelected ? "active" : ""}`}
                                    >
                                        <div className="kundli_card_main">
                                            <div className={`kundli_avatar_circle ${IsSelected ? "active" : ""}`}>
                                                {item.firstName.slice(0, 1).toUpperCase()}
                                            </div>
                                            <div className="kundli_details_column">
                                                <h2 className="kundli_user_name">{item.firstName} {item.lastName}</h2>
                                                <div className="kundli_meta_info">
                                                    <span className="kundli_meta_item">
                                                        <Calendar className="w-3.5 h-3.5" />
                                                        <span>{item.formatted}</span>
                                                    </span>
                                                    <span className="kundli_meta_item">
                                                        <MapPin className="w-3.5 h-3.5" />
                                                        <span>{item.wb_place}</span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`kundli_select_indicator ${IsSelected ? "selected" : ""}`}>
                                            {IsSelected && <Check className="w-3 h-3 text-white" />}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        {KundliList && KundliList.length > 0 && (
                            <button onClick={handleNext} className="kundli_btn_primary" disabled={!!apiloading}>
                                {apiloading
                                    ? <Btn_loader CustomeStyle={"bg-white"} />
                                    : t("Next")}
                            </button>
                        )}
                        <button onClick={() => navigate("/freekundli")} className="kundli_btn_secondary">
                            <Plus className="w-4 h-4 mr-1.5 inline-block align-text-bottom" />
                            {t("Add Kundli")}
                        </button>
                    </div>}

                    {ischatstep === 2 && <div>
                        <div className="flex items-center justify-between pb-3 mb-3 border-b border-gray-100">
                            <div className="flex items-center gap-3">
                                <button onClick={() => setIsChatStep(1)} className="p-1 rounded-full hover:bg-gray-100 transition-colors">
                                    <ArrowLeft className="w-5 h-5 text-gray-700" />
                                </button>
                                <h1 className='font-semibold text-[18px] text-gray-900'>{t("Recharge Wallet")}</h1>
                            </div>
                            <button onClick={() => handleCloseModel(1)} className="p-1 rounded-full hover:bg-gray-100 transition-colors">
                                <X className="w-5 h-5 text-gray-500 hover:text-gray-700" />
                            </button>
                        </div>
                        <div className="recharge_info_banner">
                            <p className='recharge_info_text'>
                                {t("Minimum balance of")} <strong>{handleMinReqTime()} {t("minutes")} ({formatPrice(handleGetTotalPrice())})</strong> {t("is required to start chat with")} <strong>{userdata?.name}</strong>
                            </p>
                        </div>
                        {pricelist.length <= 0 && <p className='wallet_balance_text'>{t("Wallet Balance")} :- {formatPrice(userwallet, 2)}</p>}

                        {pricelist.length >= 1 && <div className="price_grid_container">
                            <div 
                                onClick={() => setSelectPrice(seletprice?.id === 1 ? "" : { id: 1, offer_title: 0, price: Number((handleGetTotalPrice() - userwallet).toFixed(2)), status: 1 })} 
                                className={`recharge_price_card ${seletprice?.id === 1 ? "active" : ""}`}
                            >
                                <div className="price_badge">
                                    <span>{t("Required")}</span>
                                </div>
                                <p className='price_value'>{formatPrice(handleGetTotalPrice() - userwallet, 2)}</p>
                            </div>
                            {pricelist.map((item, index) => {
                                const IsSelected = item.id === seletprice.id;
                                return (
                                    <div 
                                        key={index} 
                                        onClick={() => setSelectPrice(IsSelected ? "" : item)} 
                                        className={`recharge_price_card ${IsSelected ? "active" : ""}`}
                                    >
                                        <div className="price_badge">
                                            <span>{item.offer_title}% {t("Extra")}</span>
                                        </div>
                                        <p className='price_value'>{formatPrice(item.price)}</p>
                                    </div>
                                );
                            })}
                        </div>}

                        <button disabled={apiloading === "ProceedtoPay"} onClick={handleProceedToPay} className="kundli_btn_primary">
                            {apiloading === "ProceedtoPay"
                                ? < Btn_loader CustomeStyle={"bg-white"} />
                                : t("Proceed to Pay")}
                        </button>
                    </div>}
                </div>
            </div>}

            {isextramodel && <div onClick={() => { setIsExtraModel(false); setIsChatStep(3); }} style={{ zIndex: "9999" }} className="model items-center">
                <div onClick={(e) => e.stopPropagation()} className="w-[300px] bg-white py-[20px] px-[25px] rounded-[15px]">
                    <div className='py-[30px] relative'>
                        <Lottie
                            className="w-[250px] max-_430_:w-[200px] absolute -top-[120px]"
                            animationData={ExtraLottie}
                            loop={false}
                        />
                        <img src={LottieImg} className='w-[100px] mx-auto' alt='LottieImg' />
                    </div>
                    <p className='leading-5 text-center font-medium text-[17px] text-gray-700'>{formatPrice((seletprice.price * seletprice.offer_title) / 100)} {t("extra in your")} <br /> {t("wallet with this")}</p>
                    <button onClick={() => { setIsExtraModel(false); setIsChatStep(3); }} className='w-full mt-[15px] text-[18px] text-red-500 text-center'>{t("Woohoo!")}</button>
                </div>
            </div>}

            {ispaymentmodelm && <div ref={PaymentModeRef} onClick={() => handleCloseModel(2)} className="payment_model">
                <div onClick={(e) => e.stopPropagation()} className="h-full flex flex-col">

                    <div className="flex items-center gap-[10px] py-[10px] px-[15px]">
                        <button onClick={() => handleCloseModel(2)}>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21.7501 12C21.7501 12.414 21.4141 12.75 21.0001 12.75H4.81115L10.5311 18.47C10.8241 18.763 10.8241 19.238 10.5311 19.531C10.3851 19.677 10.1931 19.751 10.0011 19.751C9.80909 19.751 9.61706 19.678 9.47106 19.531L2.47106 12.531C2.40206 12.462 2.3472 12.3791 2.3092 12.2871C2.2332 12.1041 2.2332 11.8971 2.3092 11.7141C2.3472 11.6221 2.40206 11.539 2.47106 11.47L9.47106 4.46999C9.76406 4.17699 10.2391 4.17699 10.5321 4.46999C10.8251 4.76299 10.8251 5.23803 10.5321 5.53103L4.81213 11.251H21.0001C21.4141 11.25 21.7501 11.586 21.7501 12Z" fill="#25314C" />
                            </svg>
                        </button>
                        <h1 className='font-medium text-[20px] text-gray-700'>Payment Information</h1>
                    </div>

                    <div className="h-full scroll_container">

                        <div className="px-[15px] py-[10px]">
                            <div className="border-[1px] py-[5px] px-[15px] rounded-[10px]">
                                <div className="flex items-center justify-between gap-[10px] text-[15px] py-[5px]">
                                    <h1>{t("Recharge Amount")}</h1>
                                    <p>{formatPrice(rechargeamount)}</p>
                                </div>
                                <div className="flex items-center justify-between gap-[10px] text-[15px] py-[5px]">
                                    <h1>{t("GST")} ({Tex}%)</h1>
                                    <p>{formatPrice(gstamount)}</p>
                                </div>
                                {wallettoggle && <div className="flex items-center justify-between gap-[10px] text-[15px] py-[5px]">
                                    <h1>{t("Wallet Amount")}</h1>
                                    <p>-{formatPrice(user_wallet)}</p>
                                </div>}
                                <div className="flex border-t-[1px] items-center justify-between gap-[10px] text-[15px] py-[5px]">
                                    <h1 className='font-medium text-[16px]'>{t("Payble Amount")}</h1>
                                    <p className='font-medium text-[16px]'>{formatPrice(paybleamount)}</p>
                                </div>
                            </div>
                        </div>

                        {(!seletprice && userwallet != "0") && <div className="px-[15px] py-[10px]">
                            <div className="border-[1px] py-[8px] px-[15px] rounded-[10px]">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-[10px]">
                                        <div>
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M18.75 6.297V6C18.75 3.582 17.418 2.25 15 2.25H5C3.483 2.25 2.25 3.483 2.25 5V18C2.25 20.418 3.582 21.75 6 21.75H18C20.418 21.75 21.75 20.418 21.75 18V10C21.75 7.845 20.692 6.553 18.75 6.297ZM20.25 15.75H16.5C15.535 15.75 14.75 14.965 14.75 14C14.75 13.035 15.535 12.25 16.5 12.25H20.25V15.75ZM5 3.75H15C16.577 3.75 17.25 4.423 17.25 6V6.25H5C4.311 6.25 3.75 5.689 3.75 5C3.75 4.311 4.311 3.75 5 3.75ZM18 20.25H6C4.423 20.25 3.75 19.577 3.75 18V7.44897C4.125 7.64097 4.55 7.75 5 7.75H18C19.577 7.75 20.25 8.423 20.25 10V10.75H16.5C14.708 10.75 13.25 12.208 13.25 14C13.25 15.792 14.708 17.25 16.5 17.25H20.25V18C20.25 19.577 19.577 20.25 18 20.25ZM17.01 13H17.02C17.573 13 18.02 13.448 18.02 14C18.02 14.552 17.573 15 17.02 15C16.468 15 16.015 14.552 16.015 14C16.015 13.448 16.458 13 17.01 13Z" fill="#25314C" />
                                            </svg>
                                        </div>
                                        <div className="leading-5">
                                            <h1 className='font-medium text-[17px] text-gray-700'>{t("Pay from Wallet")}</h1>
                                            <p className='text-[14px]'>{t("Available")}: {formatPrice(userwallet, 2)}</p>
                                        </div>
                                    </div>
                                    <div onClick={() => setWalletToggle(!wallettoggle)} className={`w-[40px] h-[20px] rounded-[50px] ${wallettoggle ? "bg-[--bgcolor]" : "bg-gray-300"} cursor-pointer flex items-center duration-[0.3s]`}>
                                        <div className={`w-[15px] h-[16px] bg-white rounded-full ${wallettoggle ? "translate-x-[22px]" : "translate-x-[3px]"} duration-[0.3s]`}></div>
                                    </div>
                                </div>
                            </div>
                        </div>}

                        <div className="px-[15px] pb-[10px]">
                            <h1 className='font-medium text-[18px] text-gray-700 mb-2'>{t("Payment Getway Method")}</h1>

                            <div className="">
                                {paymentlist?.map((item, index) => {
                                    const IsSelected = item.name === selectpayment;
                                    return <div key={index} onClick={() => { setSelectPayment(item.name); setAttributes(item.attribute); }} className={`border-[1px] cursor-pointer ${IsSelected ? "border-[--bgcolor]" : "border-gray-300"} px-[15px] py-[10px] mt-[10px] rounded-[15px]`}>
                                        <div className="flex items-center gap-[10px]">
                                            <div className="flex items-center gap-[20px]">
                                                <div className="max-w-[60px] min-w-[60px] border-[1px] rounded-[10px] overflow-hidden border-gray-300">
                                                    <ImageLoad url={BaseUrl + item.image} CustomeStyle={"w-full h-full object-cover"} alt={`${item.name} Logo`} />
                                                </div>
                                                <div className="leading-6">
                                                    <h1 className='font-bold text-gray-700'>{item.name}</h1>
                                                    <p className='leading-4 font-medium text-[14px] text-gray-500'>{item.sub_title}</p>
                                                </div>
                                            </div>
                                            <div className="w-[20px]">
                                                <div className={`w-[18px] h-[18px] duration-[.5s] border-[2px] ${IsSelected ? "border-[--bgcolor]" : "border-gray-300"} rounded-full p-[2px]`}>
                                                    <div className={`w-full h-full duration-[.5s] rounded-full ${IsSelected ? "bg-[--bgcolor]" : "bg-transparent"}`}></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                })}
                            </div>
                        </div>

                    </div>

                    <div className="w-full px-[15px] py-[10px]">
                        <button onClick={handleContinue} className='w-full h-[40px] rounded-[50px] text-white font-medium hover:shadow-lg duration-[.3s] bg-[--bgcolor]'>
                            {paymentloading ? <Btn_loader CustomeStyle={"bg-white"} /> : t("Continue")}
                        </button>
                    </div>

                </div>
            </div>}

            {apiloading === "Isbooking" && <div className="model items-center">
                <Btn_loader CustomeStyle={"bg-[--bgcolor]"} />
            </div>}

            {ispaymentmodelm && <div onClick={() => handleCloseModel(2)} style={{ zIndex: "8888" }} className="overlay"></div>}

            {(selectpayment == "1" && istrue) && <Razorpay Amount={paybleamount} attributes={attributes} />}
            {(selectpayment == "Razorpay" && istrue) && <Razorpay Amount={paybleamount} attributes={attributes} />}
            {(selectpayment == "Paypal" && istrue) && <AllPayment Amount={paybleamount} url={"payment/paypal-payment"} />}
            {(selectpayment == "Stripe" && istrue) && <AllPayment Amount={paybleamount} url={"payment/strip-payment"} />}
            {(selectpayment == "PayStack" && istrue) && <AllPayment Amount={paybleamount} url={"payment/paystack-payment"} />}
            {(selectpayment == "FlutterWave" && istrue) && <AllPayment Amount={paybleamount} url={"payment/flutterwave-payment"} />}
            {(selectpayment == "SenangPay" && istrue) && <AllPayment Amount={paybleamount} url={"payment/senangpay-payment"} />}
            {(selectpayment == "Payfast" && istrue) && <AllPayment Amount={paybleamount} url={"payment/payfast-payment"} />}
            {(selectpayment == "Midtrans" && istrue) && <AllPayment Amount={paybleamount} url={"payment/midtrans-payment"} />}


        </div>
    )
}

export default BookApoint;